// src/Admin/Context/AuthContext.tsx
import React, { createContext, useContext, useEffect, useState } from 'react';
import { WEBApi } from '../API/WEBApi';

type User = {
    _id: string;
    name: string;
    email: string;
};

type AuthContextType = {
    user: User | null;
    setUser: (user: User | null) => void;
    isLoading: boolean;
};

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [user, setUser] = useState<User | null>(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {

            setIsLoading(true);
            WEBApi.getUser()
                .then((data: User) => {
                    setUser(data);
                })
                .catch(() => {
                    setUser(null);
                })
                .finally(() => {
                    setIsLoading(false);
                });

    }, []);

    return (
        <AuthContext.Provider value={{ user, setUser, isLoading }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = (): AuthContextType => {
    const context = useContext(AuthContext);
    if (!context) throw new Error('useAuth must be used within an AuthProvider');
    return context;
};
